import "@/firebaseConfig";
import { initSentry } from "../../../shared/utils/sentry";
initSentry(import.meta.env.VITE_SENTRY_DSN);

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./mobile.css";
import "./ios-fixes.css";
import "./android-fixes.css";

// Initialize global error handler for production security
import { setupGlobalErrorHandler } from "../../../shared/utils/errorSanitizer";
setupGlobalErrorHandler();

// Initialize email templates for whitelabel app

// Initialize PWA features
import "./pwa-init";

// Initialize Firebase and service worker registration
import "./serviceWorkerRegistration";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
